var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnterpriseSoftwareDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 165.74 174.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{clip-path:url(#clippath);}.cls-3,.cls-4{fill:none;}.cls-4{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,0v174.86h165.74V0H0Zm112.35,165.47h-60.99v-95.99h60.99v95.99Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.54,40.27v125.21H4.55v-95.99l60.99-29.22m0-4c-.59,0-1.18.13-1.73.39L2.82,65.88c-1.39.67-2.27,2.07-2.27,3.61v95.99c0,2.21,1.79,4,4,4h60.99c2.21,0,4-1.79,4-4V40.27c0-1.37-.71-2.65-1.87-3.38-.65-.41-1.39-.62-2.13-.62h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 12.54,
    y1: 76.88,
    x2: 57.55,
    y2: 76.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 85.56,
    x2: 12.54,
    y2: 85.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 94.24,
    x2: 12.54,
    y2: 94.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 102.92,
    x2: 12.54,
    y2: 102.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 111.6,
    x2: 12.54,
    y2: 111.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 120.28,
    x2: 12.54,
    y2: 120.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 128.96,
    x2: 12.54,
    y2: 128.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 137.64,
    x2: 12.54,
    y2: 137.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 146.32,
    x2: 12.54,
    y2: 146.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.55,
    y1: 155,
    x2: 12.54,
    y2: 155
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m157.02,4.62v160.86h-60.99V4.62h60.99m0-4h-60.99c-2.21,0-4,1.79-4,4v160.86c0,2.21,1.79,4,4,4h60.99c2.21,0,4-1.79,4-4V4.62c0-2.21-1.79-4-4-4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 12.93,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 32.39,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 51.86,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 71.32,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 90.79,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 110.25,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 129.72,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.2,
    y: 149.18,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 12.93,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 32.39,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 51.86,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 71.32,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 90.79,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 110.25,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 129.72,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 134.19,
    y: 149.18,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 12.93,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 32.39,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 51.86,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 71.32,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 90.79,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 110.25,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 129.72,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.19,
    y: 149.18,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 12.93,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 32.39,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 51.86,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 71.32,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 90.79,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 110.25,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 129.72,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.18,
    y: 149.18,
    width: 4.67,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 12.93,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 32.39,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 51.86,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 71.32,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 90.79,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 110.25,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 129.72,
    width: 4.67,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.17,
    y: 149.18,
    width: 4.67,
    height: 8.58
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.34,69.49v95.99h-60.99v-95.99h60.99m0-4h-60.99c-2.21,0-4,1.79-4,4v95.99c0,2.21,1.79,4,4,4h60.99c2.21,0,4-1.79,4-4v-95.99c0-2.21-1.79-4-4-4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.05,
    y: 73.98,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.05,
    y: 93.16,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.05,
    y: 112.35,
    width: 8.92,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.83,
    y: 73.98,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.83,
    y: 93.16,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.83,
    y: 112.35,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.83,
    y: 131.53,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.83,
    y: 150.71,
    width: 8.92,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.28,
    y: 73.98,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.28,
    y: 93.16,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.28,
    y: 112.35,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.28,
    y: 131.53,
    width: 8.92,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.28,
    y: 150.71,
    width: 8.92,
    height: 8.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.8,
    y: 134.1,
    width: 17.42,
    height: 33.22,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.23,136.1v29.22h-13.43v-29.22h13.43m0-4h-13.43c-2.21,0-4,1.79-4,4v29.22c0,2.21,1.79,4,4,4h13.43c2.21,0,4-1.79,4-4v-29.22c0-2.21-1.79-4-4-4h0Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/enterpriseSoftwareDevelopment.3b0f9aaaadd5f9f88da62a025f462795.svg";
export { ForwardRef as ReactComponent };